import { FC } from 'react';
import { FiscalReports } from 'components/FiscalReports';
import { Page } from 'layouts/Page';
import { IS_NEMAN } from '../../services/constants/env';

export const FiscalReportsPage: FC = () => {
	return (
		<Page title={`Fiscal Reports – ${IS_NEMAN ? ' Neman IOSS' : 'EAS'} Control Center`}>
			<FiscalReports />
		</Page>
	);
};
